import * as React from "react";
import { Text } from "@/components/ui/shadcn-compat";

function FooterLogoAndAddress() {
  return (
    <React.Fragment>
      <img className="site-logo site-logo--footer" src="/static/images/all-good-jobs-logo-dark.png" alt="All Good Jobs" />
      <Text>2nd floor, Plot no.4, Minarch Tower</Text>
      <Text> Sector 44, Gurugram</Text>
      <Text>Haryana - 122003</Text>
    </React.Fragment>
  );
}

export default FooterLogoAndAddress;
